import { toast } from "react-toastify";
import { BASE_URL } from "../Constant";

const BASE_HEADERS = {
  "Content-Type": "application/json",
  accept: "application/json",
};

// Auto-logout: clear stale session and reload so AuthGate shows login
function handleExpiredSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("userId");
  localStorage.removeItem("tdc_retailer_settings");
  // Reload once — the missing token triggers the AuthGate login screen
  if (!window.__tdc_reloading) {
    window.__tdc_reloading = true;
    window.location.reload();
  }
}

export async function apiCall(requestMethod, url, body, onSuccess, onFailure, accessToken = null) {
  // Build fresh headers per call. The signed-in retailer's token goes with
  // every call to our own API even when the caller didn't pass it, so routes
  // serving trade data (prices, stock, costs) can require a login. Only to
  // our API's origin — never to anything else (an origin match, not a string
  // prefix: "https://api.thediamondcounter.com.example" starts with BASE_URL).
  const headers = { ...BASE_HEADERS };
  let ourApi = false;
  try { ourApi = new URL(url, window.location.href).origin === new URL(BASE_URL).origin; } catch { /* not a URL */ }
  const token = accessToken || (ourApi ? localStorage.getItem("token") : null);
  if (token) {
    headers["Authorization"] = token;
  }

  const options = { method: requestMethod, headers };

  if (body !== undefined && body !== "") {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, options);
    const responseJson = await response.json();

    // Auto-logout on expired/invalid token
    if (response.status === 401 && (responseJson.message === "token_expired" || responseJson.message === "invalid_token")) {
      handleExpiredSession();
      return;
    }

    if (
      responseJson.status === "success" ||
      response.status === 200 ||
      response.status === 201
    ) {
      onSuccess(responseJson);
    } else {
      onFailure(responseJson);
    }
  } catch (error) {
    toast.error(error);
    onFailure(error);
  }
}

export async function deleteApi(url, onSuccess, token) {
  const options = {
    method: "DELETE",
    headers: { Authorization: token },
  };

  try {
    const response = await fetch(url, options);
    const responseJson = await response.json();

    if (response.status === 401 && (responseJson.message === "token_expired" || responseJson.message === "invalid_token")) {
      handleExpiredSession();
      return;
    }

    if (
      responseJson.status === "success" ||
      response.status === 200 ||
      response.status === 201
    ) {
      onSuccess(responseJson);
    }
  } catch (error) {
    toast.error(error);
  }
}

export function imageUploadApiCall(data) {
  const formData = new FormData();
  formData.append("document", data[0]);
}
